import React from 'react';
import { Box } from '@mui/material';
import Highcharts, { charts } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import _ from 'lodash';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsSankey from 'highcharts/modules/sankey';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);
HighchartsSankey(Highcharts);
NoDataToDisplay(Highcharts);

const getOptions = (type, chartSeries, vendors) => ({
    chart: {
        type,
        height: vendors.length > 5 ? vendors.length*60: vendors.length*100,
    },
    lang: {
        noData: 'No data to display',
    },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030',
        },
    },
    title: {
        text: null,
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
          },
        formatter: function () {
            let tooltipText = '';
            if (this.point.fromNode && this.point.toNode) {
                const fromNode = this.point.fromNode.name;
                const toNode = this.point.toNode.name;
                const value = this.point.weight;
                tooltipText += `<b>${fromNode}</b> \u2192 <b>${toNode}</b>: ${value}`;
            }

            // Show connected nodes' values
            if (this.point.linksFrom && this.point.linksFrom.length > 0) {
                tooltipText += 'Outgoing Links:<br>';
                this.point.linksFrom.forEach((link) => {
                    const toNode = link.toNode.name;
                    const value = link.weight;
                    tooltipText += `<b>${toNode}</b>  ${value}<br>`;
                });
            }

            if (this.point.linksTo && this.point.linksTo.length > 0) {
                tooltipText += 'Incoming Links:<br>';
                this.point.linksTo.forEach((link) => {
                    const fromNode = link.fromNode.name;
                    const value = link.weight;
                    tooltipText += `<b>${fromNode}</b>: ${value}<br>`;
                });
            }

            return tooltipText;
        },
    },
    series: chartSeries,
});

const SankeyChart = (props) => {
    const { chartSeries, vendors } = props;
    Highcharts.seriesTypes.sankey.prototype.pointAttribs = function (
        point,
        state
    ) {
        let opacity = this.options.linkOpacity;
        let color = point.color;

        if (state) {
            opacity = this.options.states[state].linkOpacity || opacity;
            color = this.options.states[state].color || point.color;
        }

        return {
            fill: point.isNode
                ? color
                : {
                      linearGradient: {
                          x1: 0,
                          x2: 1,
                          y1: 0,
                          y2: 0,
                      },
                      stops: [
                          [
                              0,
                              Highcharts.color(color).setOpacity(opacity).get(),
                          ],
                          [
                              1,
                              Highcharts.color(point.toNode.color)
                                  .setOpacity(opacity)
                                  .get(),
                          ],
                      ],
                  },
        };
    };

    return (
            <HighchartsReact
                containerProps={{ style: { height: 'auto', width: '100%' } }}
                highcharts={Highcharts}
                options={getOptions('sankey', chartSeries, vendors)}
            />
    );
};

export default SankeyChart;
